import gql from 'graphql-tag'

import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

const query = gql`
  query UserWithFamily {
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`

export default query
